import { render } from "./InvoiceOfMonthPage.vue?vue&type=template&id=5841ba46&scoped=true&ts=true"
import script from "./InvoiceOfMonthPage.vue?vue&type=script&lang=ts"
export * from "./InvoiceOfMonthPage.vue?vue&type=script&lang=ts"

import "./InvoiceOfMonthPage.vue?vue&type=style&index=0&id=5841ba46&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5841ba46"]])

export default __exports__